const DealerRankEnum = {
  GOLD: { value: 'GD', name: 'Gold' },
  SILVER: { value: 'SV', name: 'Silver' },
  BRONZE: { value: 'BZ', name: 'Bronze' },
  NOT_RANKED: { value: 'NR', name: 'Not Ranked' },
};

export default DealerRankEnum;
